/* ========= DD LOGO ANIMATION =========
 *
 * Handles the interactive behaviour for the DD logo animation.
 *
 * Requirements:
 * - Must work on the live storefront
 * - Must also work inside the theme editor (CMS) when sections/blocks
 *   are added, removed, or re-rendered without a full page load.
 */

(() => {
    /** @type {WeakSet<HTMLElement>} */
    const initialized = new WeakSet();

    /**
     * Attach behaviour to any `[data-dd-logo]` elements within a root node.
     * @param {ParentNode} root
     */
    const initDdLogos = (root = document) => {
        const wrappers = root.querySelectorAll('[data-dd-logo]');

        wrappers.forEach((logoWrapper) => {
            if (!(logoWrapper instanceof HTMLElement)) return;
            if (initialized.has(logoWrapper)) return;
            initialized.add(logoWrapper);

            /**
             * @param {boolean} state
             */
            const setExpanded = (state) => {
                logoWrapper.classList.toggle('expanded', state);
                logoWrapper.setAttribute('aria-expanded', String(state));
            };

            logoWrapper.addEventListener('pointerenter', () => setExpanded(true));
            logoWrapper.addEventListener('pointerleave', () => setExpanded(false));
            logoWrapper.addEventListener('focus', () => setExpanded(true));
            logoWrapper.addEventListener('blur', () => setExpanded(false));
        });
    };

    // Initial run on first page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initDdLogos());
    } else {
        initDdLogos();
    }

    // Re-run when sections/blocks are loaded in the theme editor (CMS)
    document.addEventListener('shopify:section:load', (event) => {
        if (event?.target instanceof Element) initDdLogos(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
        if (event?.target instanceof Element) initDdLogos(event.target);
    });
})();